/**
 * @module websocket.event.handlers.bookings.booking-added
 */
import { store } from '../../../../state/store'
import { setBookingListUpdated } from '../../../../state/websocket.slice'

export default function handleBookingAdded(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleBookingAdded', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setBookingListUpdated(data))
  }
} 